
export default function Token () {


    const getToken = () => {
        return localStorage.getItem('token');
    };


    const saveToken = userToken => {
        if (userToken != null) {
            localStorage.setItem('token', userToken);
        }
    };

    const removeToken = () => {
        localStorage.clear()
    }

    return {
        saveToken,
        removeToken,
        getToken,
    }
}